var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#24498C",
  d: "M16.67.158a1.5 1.5 0 0 0-1.34 0l-11.5 5.75c-.505.252-.83.767-.83 1.34v8.693c0 4.882 2.707 8.876 5.56 11.598a22.7 22.7 0 0 0 4.221 3.19c.643.37 1.243.664 1.765.868.492.192 1.01.344 1.454.344s.962-.152 1.454-.344a13 13 0 0 0 1.764-.868 22.7 22.7 0 0 0 4.223-3.19C26.293 24.817 29 20.823 29 15.941V7.248c0-.573-.325-1.088-.83-1.34z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D5CB1",
  fillRule: "evenodd",
  d: "m16 2 11 5.559v8.382c0 4.118-2.292 7.624-4.94 10.152a20.7 20.7 0 0 1-3.841 2.904c-.576.332-1.085.578-1.493.737a4 4 0 0 1-.505.167 2 2 0 0 1-.221.04z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.714 11.46a1.455 1.455 0 0 1 0 2.05l-7.273 7.273c-.279.262-.65.403-1.033.393h-.145a1.46 1.46 0 0 1-1.062-.64l-2.909-4.364a1.455 1.455 0 1 1 2.415-1.614l1.92 2.909 6.021-6.022a1.455 1.455 0 0 1 2.066-.03z"
})));
export default SvgBasicBadge;